// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"loading_loadingOverlay__SIB80","spinner":"loading_spinner__9ib5h","spin":"loading_spin__EJioN","loadingText":"loading_loadingText__BRDe4"};